
// TODO 啥数据结构阿 已经搞了多少any了
import {
    defineComponent,
    PropType,
    computed,
    toRefs
} from 'vue';

import {
    ElSelect,
    ElOption,
    ElRadioGroup,
    ElRadioButton
} from 'element-plus';

export default defineComponent({
    components: {
        ElSelect,
        ElOption,
        ElRadioGroup,
        ElRadioButton
    },
    props: {
        modelValue: {
            type: Object,
            default: function () {
                return {
                    index: -1,
                    name: 'N/A'
                };
            }
        },

        isRadio: {
            type: Boolean,
            default: false
        },
        enums: {
            type: Object as PropType<Record<string, string>>,
            default: function () {
                return { '-1': 'N/A' };
            }
        },
        size: {
            // TODO 从ElSelect组件获取
            type: String as PropType<'' | 'default' | 'small' | 'large'>,
            default: ''
        }

    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        error (val:string) {
            return true;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        'update:modelValue' (val:Record<'index' | 'name', string>) {
            return true;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        change (val:Record<'index' | 'name', string>) {
            return true;
        }
    },

    setup (props, { emit }) {
        const {
            modelValue,
            enums
        } = toRefs(props);
        const realIndex = computed<string>({
            get () {
                return modelValue.value.index.toString();
            },
            set (newValue) {
                if (!enums.value[newValue]) {
                    emit('error', newValue);
                    return;
                }
                const result = {
                    index: newValue,
                    name: enums.value[newValue]
                };

                emit('update:modelValue', result);
                emit('change', result);
            }
        });

        return {
            realIndex
        };
    }

});
